import { HttpService } from '@/shared/lib'

export class LogoutService extends HttpService {
  execute = async () => {
    const response = await this.http.post<{ message: string }>(`/api/v2/Logout`)
    return response
  }
}
